<template>
<p>
This page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it.<br/>
Thank you.
</p>
</template>

<script>

export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_61e9ec31d3854190a4dd42575e275b02_C7t4i5.ch.fixed.fc.tidied.stylehacked.xfixed_split_020.vue?fa8018bc